export default __webpack_public_path__ + "static/media/BR - PowerShell Fundamentals.816cdd55.png";